export default Object.freeze({
  MAX_FILE_SIZE: 2621440,
  FIREBASE_FUNCTIONS_BASE_URL: 'https://firebase.kieswijs.nl/api',
  DEV_AUTH_WEB_BASE_URL: 'http://localhost:8080/',
  DEV_FIREBASE_FUNCTIONS_BASE_URL: 'http://localhost:5001/kieswijs-5e1a6/us-central1',
  AUTH_WEB_BASE_URL: 'https://authenticatie.kieswijs.nl/',
});
